/* PLIRU Atelier. Native Shopify data, progressively enhanced forms. */
(() => {
  'use strict';
  const config = window.Pliru || {};
  const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{{ ${name} }}`, String(value)), config.messages?.[key] || key);
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = (config.root || '/').replace(/\/?$/, '/');
  const cartRoute = config.cart || `${root}cart`;
  const money = cents => new Intl.NumberFormat(config.locale || 'pl-PL', {style:'currency', currency:config.currency || 'PLN'}).format(Number(cents) / 100);
  let lastFocus, toastTimer, cartBusy = false;
  function toast(message) {
    const el = $('.z-toast'); if (!el) return;
    el.textContent = message; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.hidden = true, 4200);
  }
  function openDialog(el) {
    if (!el || el.open) return;
    lastFocus = document.activeElement;
    el.showModal(); document.documentElement.classList.add('z-dialog-open');
  }
  function closeDialog(el) {
    if (!el) return; el.close();
    document.documentElement.classList.remove('z-dialog-open');
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
  }
  function initDialogs(scope = document) {
    $$('dialog', scope).forEach(dialog => {
      if (dialog.dataset.zBound) return; dialog.dataset.zBound = '1';
      dialog.addEventListener('click', e => { if (e.target === dialog) {const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeDialog(dialog);} });
      dialog.addEventListener('close', () => {document.documentElement.classList.remove('z-dialog-open');if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});});
    });
  }
  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    let data;try { data = await response.json(); } catch { throw new Error(t('read_error')); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : t('save_error'));
    return data;
  }
  async function refreshCart() {
    const page = $('[data-z-cart-page]');
    const pageSection = page?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
    const sections = ['z-cart-drawer', ...(pageSection ? [pageSection] : [])];
    const url = new URL(cartRoute, location.origin); url.searchParams.set('sections', sections.join(','));
    const [cart, rendered] = await Promise.all([jsonRequest(`${cartRoute}.js`), jsonRequest(url)]);
    $$('[data-z-count]').forEach(el => {el.textContent = cart.item_count;el.toggleAttribute('data-wide',cart.item_count>99);});
    const parser = new DOMParser();
    const drawerHTML = rendered['z-cart-drawer'];
    if (!drawerHTML) throw new Error(t('cart_refresh_error'));
    const incoming = parser.parseFromString(drawerHTML, 'text/html');
    const drawer = $('[data-z-drawer-content]');
    const replacement = $('[data-z-drawer-content]', incoming);
    if (drawer && replacement) drawer.replaceChildren(...replacement.childNodes);
    if (page && rendered[pageSection]) {
      const pageIncoming = parser.parseFromString(rendered[pageSection], 'text/html');
      const pageReplacement = $('[data-z-cart-page]', pageIncoming);
      if(pageReplacement) page.replaceChildren(...pageReplacement.childNodes);
    }
    document.dispatchEvent(new CustomEvent('zeips:cart-updated', {detail:cart}));
    return cart;
  }
  function showError(form, message) {
    const el = $('.z-form-error', form) || $('.z-form-error', form.closest('.z-card') || form);
    if (el) {el.textContent = message; el.hidden = false;} else toast(message);
  }
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-z-add], .z-product-form')) return;
    if (!window.fetch || !form.checkValidity()) return;
    e.preventDefault(); if (form.dataset.zBusy) return;
    form.dataset.zBusy = '1';form.setAttribute('aria-busy','true');
    const button = $('[type="submit"]', form); const previousDisabled = button?.disabled;
    if(button){button.disabled=true;button.classList.add('z-loading');}
    const oldError = $('.z-form-error', form) || $('.z-form-error', form.closest('.z-card') || form);if(oldError)oldError.hidden=true;
    let added = false;
    try {
      await jsonRequest(`${config.add || root+'cart/add'}.js`, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      added=true;
      await refreshCart();openDialog($('#z-cart'));toast(t('added'));
    } catch(error) {
      if(added){toast(t('added_redirect'));location.assign(cartRoute);}
      else showError(form,error.message);
    } finally {
      delete form.dataset.zBusy;form.removeAttribute('aria-busy');
      if(button){button.disabled=previousDisabled;button.classList.remove('z-loading');}
    }
  });
  document.addEventListener('click', async e => {
    const target = e.target.closest('button,a');if(!target)return;
    if(target.matches('[data-z-plan-open]')){const dialog=document.getElementById(target.dataset.zPlanOpen);if(dialog&&typeof dialog.showModal==='function'){e.preventDefault();openDialog(dialog);}return;}
    if(target.matches('[data-z-close]')){closeDialog(target.closest('dialog'));return;}
    if(target.matches('[data-z-menu-open]')){openDialog($('#z-menu'));return;}
    if(target.matches('[data-z-focus-search]')){const input=$('#z-search-input');window.scrollTo({top:0,behavior:'instant'});input?.focus({preventScroll:true});return;}
    if(target.matches('[data-z-cart-open]')){if(typeof HTMLDialogElement==='undefined')return;e.preventDefault();openDialog($('#z-cart'));return;}
    if(target.closest('#z-menu')&&target.tagName==='A')closeDialog($('#z-menu'));
    if(target.matches('[data-z-cart-qty]')) {
      if(cartBusy)return;cartBusy=true;
      const line=target.closest('[data-z-line]');const key=line?.dataset.zLine;
      const quantity=Number(target.dataset.zCartQty);if(!key||!Number.isInteger(quantity)||quantity<0){cartBusy=false;return;}
      const errorBox=$('[data-z-cart-error]',target.closest('dialog,.z-cart-page')||document);
      if(errorBox)errorBox.hidden=true;
      const focusIndex=$$('[data-z-cart-qty]',target.closest('[data-z-cart-content]')).indexOf(target);
      const context=target.closest('dialog')?'#z-cart':'.z-cart-page';
      $$('[data-z-cart-qty]').forEach(b=>b.disabled=true);line.classList.add('z-busy');
      let changed=false;
      try {
        await jsonRequest(`${config.change || root+'cart/change'}.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});changed=true;
        await refreshCart();toast(quantity===0?t('removed'):t('updated'));
        const buttons=$$('[data-z-cart-qty]',$(context)||document);(buttons[Math.min(focusIndex,buttons.length-1)]||$('[data-z-close]',$(context)||document))?.focus({preventScroll:true});
      }catch(error){if(changed){location.assign(cartRoute);}else if(errorBox){errorBox.textContent=error.message;errorBox.hidden=false;}else toast(error.message);}
      finally{cartBusy=false;$$('[data-z-cart-qty]').forEach(b=>b.disabled=false);line.classList.remove('z-busy');}
      return;
    }
    if(target.matches('[data-z-quantity]')) {
      const input=$('input',target.closest('.z-quantity'));
      if(!input)return;
      target.dataset.zQuantity==='1'?input.stepUp():input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    if(target.matches('[data-z-share]')) {
      const url=location.href;
      try{if(navigator.share)await navigator.share({title:document.title,url});else{await navigator.clipboard.writeText(url);toast(t('share_success'));}}catch(error){if(error.name!=='AbortError')toast(t('share_error'));}
    }
  });
  document.addEventListener('change',e=>{if(e.target.matches('[data-z-auto-submit]'))e.target.form?.requestSubmit();});
  function initSearch(scope=document) {
    $$('[data-z-search]',scope).forEach(wrapper=>{
      if(wrapper.dataset.zBound)return;wrapper.dataset.zBound='1';
      const input=$('input[type=search]',wrapper), results=$('.z-search-results',wrapper),status=$('[data-z-search-status]',wrapper);
      let timer,controller,active=-1,sequence=0;
      const hide=()=>{results.hidden=true;input.setAttribute('aria-expanded','false');input.removeAttribute('aria-activedescendant');active=-1;};
      const select=index=>{const options=$$('[role=option]',results);active=Math.max(0,Math.min(index,options.length-1));options.forEach((el,i)=>el.setAttribute('aria-selected',String(i===active)));if(options[active]){input.setAttribute('aria-activedescendant',options[active].id);options[active].scrollIntoView({block:'nearest'});}};
      input.addEventListener('input',()=>{
        clearTimeout(timer);controller?.abort();const seq=++sequence;hide();
        const q=input.value.trim();if(q.length<2){results.replaceChildren();return;}
        timer=setTimeout(async()=>{
          controller=new AbortController();
          try{
            const url=new URL(config.search||`${root}search/suggest`,location.origin);
            url.searchParams.set('q',q);url.searchParams.set('resources[type]','product,page,article');url.searchParams.set('resources[limit]','6');url.searchParams.set('section_id','z-predictive-search');
            const response=await fetch(url,{signal:controller.signal,credentials:'same-origin'});if(!response.ok)throw new Error('search');
            const html=await response.text();if(seq!==sequence)return;
            const doc=new DOMParser().parseFromString(html,'text/html');const content=$('[data-z-search-content]',doc);if(!content)throw new Error('search');
            results.replaceChildren(...content.childNodes);results.hidden=false;input.setAttribute('aria-expanded','true');active=-1;
            if(status)status.textContent=t('search_suggestions',{count:$$('[role=option]',results).length});
          }catch(error){if(error.name!=='AbortError'&&seq===sequence){hide();if(status)status.textContent=t('search_submit');}}
        },220);
      });
      input.addEventListener('keydown',e=>{
        if(e.key==='Escape'){hide();return;}
        if(results.hidden)return;
        if(e.key==='ArrowDown'){e.preventDefault();select(active+1);}else if(e.key==='ArrowUp'){e.preventDefault();select(active-1);}else if(e.key==='Enter'&&active>=0){e.preventDefault();$$('[role=option]',results)[active]?.click();}else if(e.key==='Tab'){hide();}
      });
      document.addEventListener('click',e=>{if(!wrapper.contains(e.target))hide();});
    });
  }
  function initProducts(scope=document) {
    $$('[data-z-product]',scope).forEach(container=>{
      if(container.dataset.zBound)return;container.dataset.zBound='1';
      const data=$('[data-z-variants]',container);let variants=[];try{variants=JSON.parse(data.textContent);}catch{return;}
      const select=$('[data-z-variant]',container), main=$('.z-main-image',container),original=main?.getAttribute('src');
      const form=$('.z-product-form',container);
      function updateVariant(){
        const v=variants.find(v=>String(v.id)===select.value);if(!v)return;
        $$('[data-z-product-price],[data-z-sticky-price]',container).forEach(el=>el.textContent=money(v.price));
        const sku=$('[data-z-sku]',container);if(sku)sku.textContent=v.sku||'';
        const availability=$('[data-z-availability]',container);if(availability){availability.lastElementChild.textContent=v.available?t('available'):t('unavailable');$('.z-status-dot',availability)?.classList.toggle('is-unavailable',!v.available);}
        const button=$('[data-z-product-submit]',container);button.disabled=!v.available;$('span',button).textContent=v.available?t('add_to_cart'):t('sold_out');
        const sticky=$('[data-z-sticky-submit]',container);if(sticky){sticky.disabled=!v.available;sticky.firstChild.textContent=v.available?t('add_to_cart')+' ':t('sold_out')+' ';}
        const quantity=$('input[name=quantity]',form),rule=v.quantity_rule||{min:1,increment:1};
        quantity.min=String(rule.min||1);quantity.step=String(rule.increment||1);rule.max?quantity.setAttribute('max',rule.max):quantity.removeAttribute('max');quantity.value=String(rule.min||1);
        if(v.featured_image?.src&&main){main.src=v.featured_image.src;main.removeAttribute('srcset');}
        const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);
      }
      select?.addEventListener('change',updateVariant);
      const initialURL=new URL(location.href),requested=initialURL.searchParams.get('variant');if(requested&&variants.some(v=>String(v.id)===requested)){select.value=requested;updateVariant();}
      container.addEventListener('click',e=>{
        const thumb=e.target.closest('[data-z-gallery-src],[data-z-gallery-original]');
        if(thumb&&main){main.src=thumb.hasAttribute('data-z-gallery-original')?original:thumb.dataset.zGallerySrc;main.removeAttribute('srcset');main.alt=thumb.dataset.zGalleryAlt||main.alt;$$('.z-gallery-thumbs>button',container).forEach(b=>b.classList.toggle('is-active',b===thumb));}
        if(e.target.closest('[data-z-zoom]')&&main){const zoom=$('#z-product-zoom',container);const img=$('[data-z-zoom-image]',zoom);img.src=main.src;img.alt=main.alt;openDialog(zoom);}
      });
      const sticky=$('[data-z-sticky-buy]',container);
      if(sticky&&'IntersectionObserver'in window){new IntersectionObserver(entries=>{const r=entries[0].boundingClientRect;sticky.classList.toggle('is-visible',!entries[0].isIntersecting&&r.bottom<0);},{threshold:0}).observe(form);}
    });
  }
  function initDocs(scope=document){
    $$('.z-documents img',scope).forEach(img=>{
      if(img.closest('a'))return;
      const a=document.createElement('a');a.href=img.src;a.target='_blank';a.rel='noopener';a.setAttribute('aria-label',img.alt||t('open_document'));img.parentNode.insertBefore(a,img);a.append(img);
      if(!img.hasAttribute('loading'))img.loading='lazy';
    });
  }
  function reveal(scope=document){
    if(!('IntersectionObserver'in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('is-pending');observer.unobserve(entry.target);}}),{threshold:.08});
    $$('.z-proof,.z-article-card,.z-support',scope).forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('z-reveal','is-pending');observer.observe(el);}});
  }
  function initReviews(scope=document){
    $$('[data-z-reviews]',scope).forEach(section=>{
      if(section.dataset.zReviewBound)return;section.dataset.zReviewBound='1';
      const cards=$$('[data-z-review]',section),button=$('[data-z-reviews-more]',section);
      const step=Math.max(3,Number(section.dataset.initial)||6);let shown=step;
      if(window.Shopify?.designMode||!button)return;
      const update=()=>{cards.forEach((card,i)=>card.hidden=i>=shown);button.hidden=shown>=cards.length;};
      update();button.addEventListener('click',()=>{const firstNew=cards[shown];shown+=step;update();if(firstNew){firstNew.tabIndex=-1;firstNew.focus({preventScroll:true});}});
    });
  }
  const videoDisposers=new WeakMap();
  function initHeroVideo(scope=document){
    $$('[data-z-hero-video]',scope).forEach(wrapper=>{
      if(videoDisposers.has(wrapper))return;
      const videos=$$('video',wrapper),hero=wrapper.closest('[data-z-hero]');if(!videos.length)return;
      const motion=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width: 749px)');
      let visible=true,disposed=false;
      const active=()=>mobile.matches&&videos.length>1?videos[1]:videos[0];
      const allowed=()=>!disposed&&visible&&!document.hidden&&!motion.matches&&wrapper.dataset.autoplay==='true';
      const pending=new WeakSet();
      function update(){
        const selected=active();
        videos.forEach(video=>{
          const play=video===selected&&allowed();video.autoplay=play;
          if(!play){video.pause();return;}
          if(!video.paused||pending.has(video))return;
          video.muted=true;pending.add(video);
          const attempt=video.play();
          if(attempt?.then)attempt.then(()=>{if(!allowed()||video!==active())video.pause();}).catch(()=>{}).finally(()=>pending.delete(video));
          else pending.delete(video);
        });
      }
      videos.forEach(video=>{
        video.muted=true;video.defaultMuted=true;video.playsInline=true;video.loop=true;video.controls=false;
        video.setAttribute('muted','');video.setAttribute('playsinline','');video.setAttribute('aria-hidden','true');video.tabIndex=-1;
        video.addEventListener('loadeddata',update);video.addEventListener('canplay',update);
      });
      motion.addEventListener('change',update);mobile.addEventListener('change',update);document.addEventListener('visibilitychange',update);
      document.addEventListener('pointerdown',update,{passive:true});document.addEventListener('keydown',update);
      let observer;if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;update();},{threshold:.01});observer.observe(hero);}
      videoDisposers.set(wrapper,()=>{
        disposed=true;videos.forEach(v=>{v.pause();v.removeEventListener('loadeddata',update);v.removeEventListener('canplay',update);});observer?.disconnect();
        motion.removeEventListener('change',update);mobile.removeEventListener('change',update);document.removeEventListener('visibilitychange',update);document.removeEventListener('pointerdown',update);document.removeEventListener('keydown',update);
      });
      update();
    });
  }
  const serviceDisposers=new WeakMap();
  function initServices(scope=document){
    $$('[data-z-services]',scope).forEach(carousel=>{
      if(serviceDisposers.has(carousel))return;
      const mobile=matchMedia('(max-width: 749px)'),motion=matchMedia('(prefers-reduced-motion: reduce)');
      let timer,visible=true,hovered=false,touching=false;
      const stop=()=>clearTimeout(timer);
      const schedule=()=>{
        stop();if(!mobile.matches||motion.matches||document.hidden||!visible||hovered||touching||carousel.contains(document.activeElement))return;
        timer=setTimeout(()=>{const next=carousel.scrollLeft<carousel.clientWidth/2?carousel.clientWidth:0;carousel.scrollTo({left:next,behavior:'smooth'});schedule();},4400);
      };
      const onMode=()=>{stop();carousel.scrollTo({left:0,behavior:'instant'});schedule();};
      const enter=e=>{if(e.pointerType!=='touch'){hovered=true;stop();}};
      const leave=()=>{hovered=false;schedule();};
      const down=()=>{touching=true;stop();};const up=()=>{touching=false;schedule();};
      carousel.addEventListener('pointerenter',enter);carousel.addEventListener('pointerleave',leave);carousel.addEventListener('pointerdown',down,{passive:true});
      document.addEventListener('pointerup',up,{passive:true});document.addEventListener('pointercancel',up,{passive:true});
      carousel.addEventListener('focusin',stop);carousel.addEventListener('focusout',schedule);carousel.addEventListener('scroll',schedule,{passive:true});
      document.addEventListener('visibilitychange',schedule);mobile.addEventListener('change',onMode);motion.addEventListener('change',schedule);
      let observer;if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();});observer.observe(carousel);}
      serviceDisposers.set(carousel,()=>{stop();observer?.disconnect();carousel.removeEventListener('pointerenter',enter);carousel.removeEventListener('pointerleave',leave);carousel.removeEventListener('pointerdown',down);document.removeEventListener('pointerup',up);document.removeEventListener('pointercancel',up);carousel.removeEventListener('focusin',stop);carousel.removeEventListener('focusout',schedule);carousel.removeEventListener('scroll',schedule);document.removeEventListener('visibilitychange',schedule);mobile.removeEventListener('change',onMode);motion.removeEventListener('change',schedule);});
      schedule();
    });
  }
  const headerDisposers=new WeakMap();
  function initDesktopHeader(scope=document){
    $$('[data-z-header]',scope).forEach(header=>{
      if(headerDisposers.has(header))return;
      const desktop=matchMedia('(min-width: 750px)');
      const update=()=>document.documentElement.style.setProperty('--z-header-height',desktop.matches?Math.ceil(header.getBoundingClientRect().height)+'px':'0px');
      let observer;if('ResizeObserver'in window){observer=new ResizeObserver(update);observer.observe(header);}
      desktop.addEventListener('change',update);headerDisposers.set(header,()=>{observer?.disconnect();desktop.removeEventListener('change',update);});update();
    });
  }
  document.addEventListener('shopify:section:unload',e=>{
    $$('[data-z-hero-video]',e.target).forEach(v=>videoDisposers.get(v)?.());
    $$('[data-z-services]',e.target).forEach(v=>serviceDisposers.get(v)?.());
    $$('[data-z-header]',e.target).forEach(v=>headerDisposers.get(v)?.());
  });

  function init(scope=document){initReviews(scope);initHeroVideo(scope);initServices(scope);initDesktopHeader(scope);initDialogs(scope);initSearch(scope);initProducts(scope);initDocs(scope);reveal(scope);}
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:select',e=>$$('.is-pending',e.target).forEach(el=>el.classList.remove('is-pending')));
  window.addEventListener('pageshow',e=>{if(e.persisted)refreshCart().catch(()=>{});});
})();
